
<template>
    <div class="xr-signin-com" v-if="signShow">      
      <div class="closeBtn fa fa-no2" @click="closeSign"></div>
      <template v-if="signType == 'signType1'"><!--未签到-->
        <div class="signType1">
          <div class="signin-ad1">
            <img style="width: 75%;" src="/static/signin/bg3.png" class="signin-ad1" ref="bgImg">
          </div>
          <!-- <div class="text">
            每月1日十名额外 <span>+{{signTypeMoreIntegral}}</span> 积分<br />逢9日签到   <span>+运气积分</span>
          </div> -->
          <div class="test-are" :style="{top: fontHeight+'px'}"> 
            今日签到可得{{signIntegral}}积分
          </div>
          <div class="btn-list">
            <button class="btn" @click="signin">签到</button>
          </div>
          
        </div>
      </template>
      <template v-else-if="signType == 'signType2'"><!--已签到-->
        <div class="signType2">
          <div class="signin-ad1">
            <img style="width: 75%;" src="/static/signin/bg1.png" class="signin-ad1" ref="bgImg">
          </div>
          <!-- <div class="text">
            每月1日十名额外 <span>+{{signTypeMoreIntegral}}</span> 积分<br />逢9日签到   <span>+运气积分</span>
          </div> -->
          <div class="test-are" :style="{top: fontHeight+'px'}">
            明日逢9签有惊喜
          </div>
          <div class="bigtext" :style="{top: integralHeight+'px'}">
            +{{signIntegral}}
          </div>
          <div class="btn-list">
            <button class="btn">已签到{{signDay}}天</button>
          </div>
        </div>
      </template>
      <template v-else-if="signType == 'signType3'"><!--断签-->
        <div class="signType3">
          <div class="signin-ad1">
            <img style="width: 75%;" src="/static/signin/bg2.png" class="signin-ad1" ref="bgImg">
          </div>
          <!-- <div class="text">
            每月1日十名额外 <span>+{{signTypeMoreIntegral}}</span> 积分<br />逢9日签到   <span>+运气积分</span>
          </div> -->
          <div class="test-are" :style="{top: fontHeight+'px'}">
            连续签到断开
          </div>
          <div class="btn-list">
            <button class="btn" @click="signin">重签</button>
            <router-link class="btn" to="/usercenter/sign">补签</router-link>
          </div>
        </div>
      </template>
    </div>
</template>
<script>
export default {
    name :'XR-signin',
    data(){
      return {
        signShow:false,
        signType:'',
        fullWidth: document.documentElement.clientWidth,
        fontHeight: 0,
        integralHeight:0,
        islogin : false
      }
    },
    mounted(){
      
      if(this.$store.state.user.SessionId){
        this.islogin = true
      }

      var bfb = 290 / 593
      this.fontHeight = parseInt(0.75 * this.fullWidth / 533 * 593 * bfb)+18
      bfb = 380 / 593
      this.integralHeight = parseInt(0.75 * this.fullWidth / 533 * 593 * bfb)+18

      this.BindDataSignTrace()
    },
    methods: {
      show(){
        if(this.islogin){
          this.signShow = true
        }
      },
      BindDataSignTrace() {

          var ths = this;   
          ths.$post(
            "/Shop/UserServer/GetSigninGiveDayInfo"
          ).then(function(result) {
            if(!result.IsSuccess){
              if (result.TypeId != -10000) {
                  return;
              }
            }
                       
            var signDate = new Date()
            var month = signDate.getMonth()+1
            if(month < 10){
              month = '0'+month
            }
            var day = signDate.getDate()
            if(day<10){
              day = '0'+day
            }
            var signDateString = signDate.getFullYear()+"-"+month+"-"+day
            
            var isnowsign = false; //是否今天已签到
            var isyesterdaysign = false; //是否昨天已签到
            var SignInfo = result.Data; //签到信息
            var NowSignInfo; //今天签到情况信息
            if (result.IsSuccess) {
                $.each(SignInfo.itemlist, function (i, j) {
                    if (j.date.substring(0, 10) == signDateString) {
                        NowSignInfo = j;
                    }
                });
                if (NowSignInfo){
                  if (NowSignInfo.issign)//今天已签到
                  {
                      isnowsign = true;
                  }
                  if (NowSignInfo.signcount > 1)//昨天已签到
                  {
                      isyesterdaysign = true;
                  }
                }
            }

            if (!ths.islogin)//未登录
            {
                //ths.UnLoginData(SignInfo, NowSignInfo);
            }
            else//已登录
            {
                if (isnowsign)//今天已签到
                {
                    ths.LoginSignInData(SignInfo, NowSignInfo);
                }
                else//今天未签到
                {
                    if (isyesterdaysign)//昨天已签到
                    {
                        ths.LoginUnSignInYestSignInData(SignInfo, NowSignInfo);
                    }
                    else//昨天未签到
                    {
                        ths.LoginUnSignInYestUnSignInData(SignInfo, NowSignInfo);
                    }
                }
            }              
          });
      },
      //已登录今天已签到
      LoginSignInData(SignInfo, NowSignInfo) {
        this.signType = 'signType2'
        this.signDay = NowSignInfo.signcount
        this.signIntegral = NowSignInfo.signpoint
      },
      //已登录今天未签到昨天已签到
      LoginUnSignInYestSignInData(SignInfo, NowSignInfo) {
        this.signType = 'signType1'
        this.signDay = NowSignInfo.signcount - 1
        this.signIntegral = NowSignInfo.signpoint
      },
      //已登录今天未签到昨天未签到
      LoginUnSignInYestUnSignInData(SignInfo, NowSignInfo) {
        this.signType = 'signType3'
      },
      signin(){          
        var signDate = new Date()
        var signDateString = signDate.getFullYear()+"-"+(signDate.getMonth()+1)+"-"+signDate.getDate()
        
        const ths = this;
        this.$post("/Shop/UserServer/MemberSignin" , {SignDate: signDateString})
        .then(function(res) {
          if (res.IsSuccess) {        
            ths.BindDataSignTrace()
          }else{          
            
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      },
      closeSign(){
        this.signShow = false        
        this.$emit('onClose')
      }
    }
  }
</script>
<style>
.xr-signin-com {
  position: fixed;
  top:0; 
  bottom:0; 
  z-index: 3;
  padding-top: 80px;
  background:rgba(0,0,0,0.7);
}
.xr-signin-com .closeBtn{
  color:white;
  position: absolute;
  right:30px;
  z-index: 10;
  font-size: 18px;
  border-radius: 50%;
  border:1px solid white;
}
.xr-signin-com #sign-today-box{position:fixed;top:0;left:0;width:100%;height:100%;display:none;background:rgba(0,0,0,.4);z-index:9000;}
.xr-signin-com .sign-today-content{background-color:#fff;width:75.65125vmin;position:absolute;left:12.174375vmin;top:16%;overflow:hidden; }
.xr-signin-com .stc-message-box{background:rgba(0,0,0,.7);width:75.65125vmin;position:absolute;left:0;top:100%;overflow:hidden; height:100%; z-index:999;}  
.xr-signin-com .stc-message-box.signined { top:0;}
.xr-signin-com .signin-ad1{text-align: center; margin-right: 0px; position: relative; background-repeat: no-repeat;}

.xr-signin-com .text span{color: red;font-weight: 600;}
.xr-signin-com .coin{position: relative;right: -350px;top: 80px;}
 

.xr-signin-com .test-are{font-size: 11px;text-align: center;color: white; position: absolute;left:0;right: 0;text-align: center;}
.xr-signin-com .btn-list{
  width: 100%;
  padding: 0 20%;
  margin-top: 20px;
}

.xr-signin-com .signType1 { position: relative;}
.xr-signin-com .signType1 .text{
  font-size: 11px;
  text-align: center;
  color: white;
  position: absolute;
  top: -240px;
}
.xr-signin-com .signType1 .text span{color: red;font-weight: 600;}

.xr-signin-com .signType1 .btn{
  height: 40px; 
  font-size: 14px;
  font-weight: 500; 
  vertical-align: middle;
  color: white;
  background: #fbb03b;
  border: 0px;
  width: 90%;
}
 

.xr-signin-com .signType2 { position: relative;}
.xr-signin-com .signType2 .text{font-size: 11px;text-align: center;color: white;position: relative;top: -235px;}
.xr-signin-com .signType2 .bigtext{
  font-size: 34px;
  text-align: center;
  color: yellow;
  position: absolute;
  width: 70%;
}

.xr-signin-com .signType2 .btn{
  height: 40px; 
  font-size: 12px;
  font-weight: 500; 
  color: white;
  background: #4D4D4D;
  border: 0px;
  width: 90%;
}


.xr-signin-com .signType3 { position: relative;}
.xr-signin-com .signType3 .test-are{
  font-size: 11px;
  text-align: center;
  color: white;
  position: absolute;
}

.xr-signin-com .signType3 .btn{
  background: #FBB03B; 
  width: 44%;
  height: 40px; 
  border: 0px; font-size: 14px;color: white; 
  vertical-align: middle;
  display: inline-block;
  line-height: 40px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/signin/signin.vue